module.exports = __webpack_public_path__ + "assets/img/loader.c0f0df58.gif";